import { render, staticRenderFns } from "./BackToTopIcon.vue?vue&type=template&id=4b9d4428&"
import script from "./BackToTopIcon.vue?vue&type=script&lang=ts&"
export * from "./BackToTopIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports